import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { FlagMessageCopyLink } from '@/component/ticketList/DetailTicketList';
import { IconButton, Tooltip } from '@material-ui/core';
import React, { useCallback, useMemo, useState } from 'react';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CopyShareLinkListItem({ dataShareLink, publicStatus }) {
    useTranslationSubscription();
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);

    const isVisible = useMemo(() => {
        if (!dataShareLink) return false;
        const { shortKey, type, generateLinkCorporationDomain } = dataShareLink;
        if (!shortKey || !type || !generateLinkCorporationDomain) return false;
        if (publicStatus === Constant.TICKET_PUBLIC.DRAFT) return false;
        return true;
    }, [dataShareLink, publicStatus]);

    const onClickCopyShareLink = useCallback((event) => {
        event.stopPropagation();
        const { shortKey, type, generateLinkCorporationDomain } = dataShareLink;
        const linkUrl = `${window.location.origin}/${Utils.getUrlShortShareLinkTicket({
            type,
            shortKey,
            subDomain: generateLinkCorporationDomain
        })}`;
        navigator.clipboard.writeText(linkUrl).then(() => {
            setIsShowFlagMessage(true);
            setTimeout(() => {
                setIsShowFlagMessage(false);
            }, 3000);
        }).catch(() => {
            // Clipboard API is not avaliable or blocked
        });
    }, [dataShareLink]);

    if (!isVisible) return null;

    return (
        <Tooltip
            title={trI18n('LABEL-CHATPOST-SHARELINK-TOOLTIP')}
            arrow={true}
            placement="bottom"
        >
            <IconButton
                className="copy-share-link-list-item"
                onClick={onClickCopyShareLink}
                data-cy="copy-share-link-list-item"
                size="small"
            >
                <FlagMessageCopyLink
                    title={trI18n('KNOWDEMSG002')}
                    placement="top-start"
                    arrow={true}
                    open={isShowFlagMessage}
                >
                    <img src="/assets/image/icon-link-share.svg" alt="" />
                </FlagMessageCopyLink>
            </IconButton>
        </Tooltip>
    );
}
